module.exports = __webpack_public_path__ + "img/product_42.53b138e.webp";